export const advisorOptions = [
  {
    id: 'home',
    label: 'Mijn hele huis',
    description: 'Zonnepanelen op het dak, ’s avonds zelf gebruiken',
    productId: 'ampra-stack',
  },
  {
    id: 'balcony',
    label: 'Balkonpanelen',
    description: 'Een paar panelen, stekker in het stopcontact',
    productId: 'zendure-solarflow-2400',
  },
  {
    id: 'mobile',
    label: 'Kamperen & noodstroom',
    description: 'Draagbare stroom, onderweg of bij uitval',
    productId: 'ecoflow-delta-3-plus',
  },
] as const;
